export const isJakartaMonth = (month: number): boolean => {
  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone: 'Asia/Jakarta',
    month: 'numeric',
  });
  const currentMonth = Number(formatter.format(new Date()));
  return currentMonth === month;
};
